import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';

import EditorPane from 'app/EditorPane/container';
import PageComponentsList from 'app/PageComponentsList/container';
import { Arrow } from 'ui/Components';

import { PAGE_TEMPLATES } from '../const';
import styles from './Editor.css';

/**
 * Determines whether to show the component or page editor
 */
export default class Editor extends Component {
  static propTypes = {
    applicationMode: propTypes.string
  };

  static defaultProps = {
    applicationMode: PAGE_TEMPLATES
  };

  constructor(props) {
    super(props);

    this.state = {
      showPane: true,
      renderToggleButton: true
    };

    this.handleCollapse = this.handleCollapse.bind(this);
    this.shouldRenderToggleButton = this.shouldRenderToggleButton.bind(this);
  }

  handleCollapse() {
    this.setState(ps => ({ showPane: !ps.showPane }));
  }

  /**
   * handle whether toggle should be rendered
   * @param {boolean} value - true/false
   */
  shouldRenderToggleButton(value) {
    this.setState({ renderToggleButton: Boolean(value) });
  }

  render() {
    const { applicationMode } = this.props;
    const { showPane, renderToggleButton } = this.state;

    const Component = applicationMode === PAGE_TEMPLATES ? PageComponentsList : EditorPane;

    return (
      <Fragment>
        <Component
          showPane={showPane}
          shouldRenderToggleButton={this.shouldRenderToggleButton}
        />
        {renderToggleButton && (
          <div>
            <Button
              color="light"
              className={classnames('border-secondary border', styles.toggleButton)}
              onClick={this.handleCollapse}
              data-test-id="editor-collapse"
            >
              <Arrow facing={showPane ? 'right' : 'left'} theme={styles.toggleSideArrow} />
            </Button>
          </div>
        )}
      </Fragment>
    );
  }
}
